import ReactTooltip from "react-tooltip";
import moment from "moment";

export const caseLookupColumns = ({ selectedCase, caseOne, handleSelect }) => [
  {
    id: "radio",
    accessor: "",
    Cell: ({
      row: {
        original: { caseNumber, userId },
      },
    }) => {
      return (
        <>
          <input
            type="radio"
            name="pwd-selection"
            className="usa-radio-input"
            id={`${caseNumber}`}
            onChange={(e) => e}
            checked={selectedCase === caseNumber}
            onClick={(e) => {
              handleSelect(e, userId);
            }}
            value={caseNumber}
          />
          <label
            className="usa-radio-label"
            htmlFor={`${caseNumber}`}
            onChange={(e) => e}
            checked={caseOne === caseNumber}
          />
        </>
      );
    },
    disableSortBy: true,
    fixedWidth: 25,
  },
  {
    Header: "Case Number",
    id: "caseNumber",
    minWidth: 200,
    maxWidth: 210,
    accessor: (d) => d["caseNumber"],
    Cell: ({ value, row: { index }, column: { id } }) => {
      return (
        <>
          <span data-tip data-for={`${id}${index}`}>
            {value}
          </span>
          <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
            {value}
          </ReactTooltip>
        </>
      );
    },
  },
  {
    Header: "Employer Name",
    id: "empBusinessName",
    minWidth: 200,
    accessor: (d) => d["empBusinessName"],
    Cell: ({ value, row: { index }, column: { id } }) => {
      return (
        <>
          <span data-tip data-for={`${id}${index}`}>
            {value}
          </span>
          <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
            {value}
          </ReactTooltip>
        </>
      );
    },
  },
  {
    Header: "Job Title",
    id: "jobTitle",
    minWidth: 200,
    accessor: (d) => d["jobTitle"],
    Cell: ({ value, row: { index }, column: { id } }) => {
      return (
        <>
          <span data-tip data-for={`${id}${index}`}>
            {value}
          </span>
          <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
            {value}
          </ReactTooltip>
        </>
      );
    },
  },
  {
    Header: "Dates of Need",
    id: "jobBeginDate",
    accessor: (d) => d["jobBeginDate"],
    minWidth: 190,
    maxWidth: 200,
    Cell: ({ value, row: { index, original }, column: { id } }) => {
      const startDate = value
        ? moment(Number(parseInt(value) + 18000000)).format("MM/DD/YYYY")
        : "";

      const endDate = original?.jobEndDate
        ? moment(Number(parseInt(original?.jobEndDate) + 18000000)).format(
            "MM/DD/YYYY"
          )
        : "";

      const formattedValue =
        endDate && startDate ? startDate + " - " + endDate : "--";

      return (
        <>
          <span data-tip data-for={`${id}${index}`}>
            {formattedValue}
          </span>
          <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
            {formattedValue}
          </ReactTooltip>
        </>
      );
    },
  },
  {
    Header: "Submitted Date",
    id: "dateSubmitted",
    minWidth: 130,
    maxWidth: 140,
    accessor: (d) => d["dateSubmitted"],
    Cell: ({ value, row: { index }, column: { id } }) => {
      const _date = value ? moment(Number(value)).format("MMMM D, YYYY") : "";
      return (
        <>
          <span data-tip data-for={`${id}${index}`}>
            {_date}
          </span>
          <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
            {_date}
          </ReactTooltip>
        </>
      );
    },
  },
  {
    Header: "SWA Decision",
    id: "caseStatus",
    minWidth: 300,
    accessor: (d) => d["caseStatus"],
    Cell: ({ value, row: { index }, column: { id } }) => {
      return (
        <>
          <span data-tip data-for={`${id}${index}`}>
            {value?.toUpperCase()}
          </span>
          <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
            {value?.toUpperCase()}
          </ReactTooltip>
        </>
      );
    },
  },
];
